<template>
  <div></div>
</template>
<script>
import packageInfo from "../../package.json";

export default {
  name: "Health",
  mounted() {
    const healthDate = {
      service: packageInfo.name,
      version: packageInfo.version,
      status: "200",
      note: ""
    };

    // Display health data as formatted JSON
    document.body.innerHTML = `<pre>${JSON.stringify(
      healthDate,
      null,
      2
    )}</pre>`;
    document.body.style.margin = "0px";
    document.body.style.padding = "20px";
    document.body.style.fontFamily = "monospace";
    document.body.style.fontSize = "14px";
  }
};
</script>
